import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class FullscreenService {
  private isFullscreenSubject = new BehaviorSubject<boolean>(false);
  isFullscreen$ = this.isFullscreenSubject.asObservable();

  private fullscreenSource: 'header' | 'child' | null = null;

  constructor() {
    document.addEventListener('fullscreenchange', () => {
      const isFullscreen = !!document.fullscreenElement;

      // Remove all fullscreen-related classes when exiting fullscreen
      if (!isFullscreen) {
        document.body.classList.remove('fullscreen-from-header');
        document.body.classList.remove('fullscreen-from-child');
        this.fullscreenSource = null;
      }

      this.isFullscreenSubject.next(isFullscreen);
    });
  }

  // Open fullscreen
  openFullscreen(source: 'header' | 'child') {
    // Remove previous class if set
    if (this.fullscreenSource) {
      document.body.classList.remove(`fullscreen-from-${this.fullscreenSource}`);
    }

    // Set current source
    this.fullscreenSource = source;
  
    // Only add class to body (no fullscreen API call)
    document.body.classList.add(`fullscreen-from-${source}`);
  }
  

  // Close fullscreen
  closeFullscreen() {
    if (document.fullscreenElement) {
      document.exitFullscreen();
    }
  }
}
